import React from "react";

/**
 * The accreditation footer strip printed on every certificate page: red/green
 * bar, seven linked logos and the contact lines. `logos` items carry a
 * resolved `imageUrl`. Used inside CertificateDocument and as the live view on
 * the Configuration page.
 */
const CertificateFooter = ({ assetsBase = "", logos = [], website, email, gmail, className = "" }) => (
  <div className={`cc-pdf-footer ${className}`.trim()}>
    <img className="cc-pdf-footer-bar" src={`${assetsBase}/footer-bar.jpg`} alt="" />
    <div className="cc-pdf-footer-row">
      <div className="cc-pdf-footer-logos">
        {logos.map((logo) => (
          <a key={logo.key} href={logo.url || undefined} target="_blank" rel="noreferrer" title={logo.name}>
            {logo.imageUrl && <img src={logo.imageUrl} alt={logo.name} />}
          </a>
        ))}
      </div>
      <div className="cc-pdf-footer-contact">
        {website && <div>{website}</div>}
        {email && <div>{email}</div>}
        {gmail && <div>{gmail}</div>}
      </div>
    </div>
  </div>
);

export default CertificateFooter;
